import {Route, Routes} from 'react-router-dom';
import {IndexPage} from './pages/IndexPage';
import {SavePaymentMethodPage} from './pages/SavePaymentMethodPage';
import {OneTimePaymentPage} from './pages/OneTimePaymentPage';
import {SubscriptionFlowPage} from './pages/SubscriptionFlowPage';
import {PayWithSavedMethodPage} from './pages/PayWithSavedMethodPage';
import {CancelSubscriptionPage} from './pages/CancelSubscriptionPage';
import {UpdateSubscriptionPage} from './pages/UpdateSubscriptionPage';
import {InvoicePaymentPage} from './pages/InvoicePaymentPage';
import {DeclinedCardPage} from './pages/DeclinedCardPage';
import {ThreeDSecurePage} from './pages/ThreeDSecurePage';

export const PaymentFlowTesterLayout = () => {
    return (
        <Routes>
            <Route path="/" element={<IndexPage/>}/>
            <Route path="/save-payment-method" element={<SavePaymentMethodPage/>}/>
            <Route path="/one-time-payment" element={<OneTimePaymentPage/>}/>
            <Route path="/subscription" element={<SubscriptionFlowPage/>}/>
            <Route path="/pay-with-saved-method" element={<PayWithSavedMethodPage/>}/>
            <Route path="/cancel-subscription" element={<CancelSubscriptionPage/>}/>
            <Route path="/update-subscription" element={<UpdateSubscriptionPage/>}/>
            <Route path="/invoice-payment" element={<InvoicePaymentPage/>}/>
            <Route path="/declined-card" element={<DeclinedCardPage/>}/>
            <Route path="/3d-secure" element={<ThreeDSecurePage/>}/>
        </Routes>
    );
};
